import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Card, Form, Input, Select, Tag, message, Spin } from 'antd';
import { api } from '../../contexts/AuthContext';

const AdminManagement = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/admins');
      setAdmins(response.data.admins);
    } catch (error) {
      message.error('获取管理员列表失败');
      console.error('获取管理员列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      await api.post('/admin/admins', values);
      message.success('管理员创建成功');
      setModalVisible(false);
      form.resetFields();
      fetchAdmins();
    } catch (error) {
      message.error(error.response?.data?.error || '创建失败');
      console.error('创建失败:', error);
    }
  };

  const columns = [
    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '昵称',
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
    },
    {
      title: '管理员级别',
      dataIndex: 'admin_level',
      key: 'admin_level',
      render: (val) => {
        const colors = {
          'super': 'red',
          'senior': 'orange',
          'regular': 'blue',
        };
        const labels = {
          'super': '超级管理员',
          'senior': '高级管理员',
          'regular': '普通管理员',
        };
        return <Tag color={colors[val]}>{labels[val]}</Tag>;
      },
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 160,
      render: (val) => val ? new Date(val).toLocaleString('zh-CN') : '-',
    },
    {
      title: '状态',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (val) => (
        <Tag color={val ? 'green' : 'red'}>
          {val ? '活跃' : '禁用'}
        </Tag>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2>管理员管理</h2>
        <Button type="primary" onClick={() => setModalVisible(true)}>
          创建管理员
        </Button>
      </div>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card>
          <Table
            dataSource={admins}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            locale={{ emptyText: '暂无管理员' }}
          />
        </Card>
      )}

      <Modal
        title="创建管理员"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="username"
            label="用户名"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input placeholder="请输入用户名" />
          </Form.Item>
          <Form.Item
            name="email"
            label="邮箱"
            rules={[{ required: true, message: '请输入邮箱' }, { type: 'email', message: '请输入有效的邮箱' }]}
          >
            <Input placeholder="请输入邮箱" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }, { min: 6, message: '密码至少6个字符' }]}
          >
            <Input.Password placeholder="请输入密码" />
          </Form.Item>
          <Form.Item
            name="nickname"
            label="昵称"
          >
            <Input placeholder="请输入昵称" />
          </Form.Item>
          <Form.Item
            name="admin_level"
            label="管理员级别"
            initialValue="regular"
            rules={[{ required: true, message: '请选择管理员级别' }]}
          >
            <Select>
              <Select.Option value="senior">高级管理员</Select.Option>
              <Select.Option value="regular">普通管理员</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              创建
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AdminManagement;